import React from "react";    
import ConfirmEmailForm from "../../components/Auth/ConfirmEmailForm";

const ConfirmEmail = () => {
  return (
    <>
      <ConfirmEmailForm />
    </>
  );
};

export default ConfirmEmail;
